import { render, staticRenderFns } from "./AccessibilityPolicy.vue?vue&type=template&id=1505348c&"
import script from "./AccessibilityPolicy.vue?vue&type=script&lang=js&"
export * from "./AccessibilityPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports